import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import Paper from "@material-ui/core/Paper";

const styles = () => ({
	warn : {
		backgroundColor : '#FAFAFA',
		borderLeft : '3px solid #FFC107',
		padding : '20px 30px',
		marginTop : 10,
		marginBottom: 10,
		lineHeight : 1.5,
		fontSize : 17,
	},
	info : {
		backgroundColor : '#FAFAFA',
		borderLeft : '3px solid #4FC3F7',
		padding : '20px 30px',
		marginTop : 10,
		marginBottom: 10,
		lineHeight : 1.5,
		fontSize : 17,
	},

});

class Note extends Component {
	render () {
		const {label, classes, children, type} = this.props;
		const className = (type) ? type : 'warn';
		return (
			<Paper className={classes[className]}>
				{!children &&
					<Fragment><strong>Note</strong>: {label}</Fragment>
				}
				{children}
			</Paper>
		);
	}
}

Note.propTypes = {
	label :	PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	classes: PropTypes.object.isRequired,
	type : PropTypes.string,
	children : PropTypes.node,

};

export default _.flow([
	withStyles(styles),
])(Note);
